/** Prezzo destinato alle superfici cliente. Un prezzo interno non è mai pubblico. */
export interface PropertyPrice {
  price?: number | null;
  price_on_request?: boolean | null;
  type?: string;
  size?: number | null;
}

export const hasPublicPrice = (property: PropertyPrice): property is PropertyPrice & { price: number } =>
  property.price_on_request !== true &&
  typeof property.price === 'number' &&
  Number.isFinite(property.price) && property.price >= 0;

export const getPropertyPriceLabel = (property: PropertyPrice): string => {
  if (property.price_on_request === true) return 'Trattativa riservata';
  if (!hasPublicPrice(property)) return 'Prezzo non disponibile';
  return new Intl.NumberFormat('it-IT', {
    style: 'currency', currency: 'EUR', maximumFractionDigits: 0,
  }).format(property.price);
};

/** Nessun canone o prezzo al metro quadro è derivabile quando il prezzo è riservato. */
export const getPropertyPriceDetail = (property: PropertyPrice): string | null => {
  if (!hasPublicPrice(property)) return null;
  if (property.type === 'affitto') return '/mese';
  if (property.type === 'vendita' && typeof property.size === 'number' && property.size > 0) {
    return `${Math.round(property.price / property.size).toLocaleString('it-IT')} €/m²`;
  }
  return null;
};

/** Spread nei dati strutturati: nessun importo o valuta fittizia per prezzi riservati. */
export const getPublicPriceFields = (property: PropertyPrice): { price?: number; priceCurrency?: 'EUR' } =>
  hasPublicPrice(property) ? { price: property.price, priceCurrency: 'EUR' } : {};
